import React from 'react'
import { KeyboardTypeOptions } from 'react-native'
import { InputField } from '@vatom/wombo'
import { Box } from 'native-base'

import Error from './Error'
import LabelForm from './Label'
import { fieldPropsInterfaceItem } from './Types'

type types = fieldPropsInterfaceItem & { keyboardType?: KeyboardTypeOptions }

export default function StringField(props: types) {
  return (
    <Box>
      <LabelForm {...props} />
      <InputField
        borderWidth="1"
        borderColor="rgb(196, 196, 196)"
        borderRadius="4px"
        placeholder={props.field.placeholder}
        w="100%"
        name={props.field.name}
        required={props.field.required}
        pattern={props.field.pattern}
        onChangeText={e => props.onChange(props.field.name, e)}
        value={props.value ?? ''}
        keyboardType={props.keyboardType}
      />
      <Error {...props} />
    </Box>
  )
}
